module.exports = __webpack_public_path__ + "assets/ubike2.jpg?f92581fdc8dd5d993ef475268d2a9589";